import styled from '@emotion/styled';
import CharacterLiked from '../CharacterLiked/CharacterLiked';
import CreatorTag from '../CreatorTag/CreatorTag';

interface CharacterImageProps {
  id: string;
  image: string;
  create_username?: string;
  is_liked: boolean;
  handleLikeClick: (id: string, isLiked: boolean) => void;
}

export default function CharacterImage({
  image,
  create_username,
  id,
  is_liked,
  handleLikeClick,
}: CharacterImageProps) {
  return (
    <CharacterImageBox>
      <img src={image} alt='character' />
      {create_username && (
        <UserNameBox>
          <CreatorTag create_username={create_username} />
        </UserNameBox>
      )}
      <UserLikedBox>
        <CharacterLiked
          id={id}
          is_liked={is_liked}
          handleLikeClick={handleLikeClick}
        />
      </UserLikedBox>
    </CharacterImageBox>
  );
}

export const CharacterImageBox = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: 4px;
  ${(props) => props.theme.mixins.aspectRatio.ratio1_1};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 16px;
  }
`;

export const UserNameBox = styled.div`
  position: absolute;
  top: 8px;
  left: 8px;
  width: 90%;
`;

export const UserLikedBox = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
`;
